var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaPennsylvaniaKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-20 -20 221.92 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.96V122h46.94V7.39L0 3.96",
    fill: "#d1232a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.22 67.75h.25l8.76-22a2.75 2.75 0 0 0-.39-3l-2.45-3.22c-.12-.25-.25-.38-.25-.51s.13-.39.64-.39h13.21c.38 0 .51.13.51.52s-.13.51-.64 1l-2.32 2.18A11.79 11.79 0 0 0 35 45.17l-9.01 22.58 11.71 34.7a7.63 7.63 0 0 0 1.42 2.58l3.6 3.47a1.31 1.31 0 0 1 .64 1 .61.61 0 0 1-.64.65H28.43c-.51 0-.51-.26-.51-.52a2.62 2.62 0 0 1 .51-1l1.42-1.88a3.14 3.14 0 0 0 .13-2.19L21.35 78.9l-2.13 5.53v20.32a1.18 1.18 0 0 0 .51 1l3.09 3a1.63 1.63 0 0 1 .52.9c0 .39-.39.52-.78.52H6.22c-.52 0-.78-.13-.78-.52a1.11 1.11 0 0 1 .52-.9l3.73-3a1.17 1.17 0 0 0 .52-1v-85.7a1.17 1.17 0 0 0-.52-1l-3.73-3a1.12 1.12 0 0 1-.52-.9c0-.39.26-.52.78-.52h12.3c.52 0 .65.26.65.77z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.94 14.74v100.88h46.94V10.57l-46.94 4.17",
    fill: "#1e3278"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.54 73.67c0 16.22 2.19 22.4 8.11 22.4 4.25 0 6.31-2.06 9-6 .26-.39.52-.64.9-.64s.52.25.39.77c-1.55 6.18-5.54 11.45-11.84 11.45-11.72 0-16.61-11.58-16.61-40.41 0-19.57 5.67-31.15 14.68-31.15 7.46 0 13.9 5.4 13.9 24.2v8c0 .9-.26 1.54-1.16 1.54H64.54zm9.53-14.8V46c0-6.82-1.8-10.43-4.89-10.43-3.35 0-4.64 3.61-4.64 10.43v12.87z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.88 3.54v113.78l46.94 4.68.74-122-47.68 3.54",
    fill: "#d1232a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.94 30.15h.28c2.32-2.45 4.5-4.5 8.88-4.5 6.44 0 10.68 4.5 10.68 13.12v51.36c0 .51 0 .9.26 1.16l4 4.5a1.66 1.66 0 0 1 .52.9c0 .39-.39.52-.78.52h-17c-.51 0-.77-.13-.77-.52a1.66 1.66 0 0 1 .52-.9l4-4.5c.25-.26.25-.65.25-1.16V38.65c0-4.9-1.41-7.47-4.37-7.47s-6.44 4.25-6.44 11.2v47.75a2.86 2.86 0 0 0 .13 1.16l4 4.5a1.33 1.33 0 0 1 .64.9c0 .39-.38.52-.77.52h-17c-.51 0-.77-.13-.77-.52a1.14 1.14 0 0 1 .51-.9l4-4.5c.26-.26.26-.65.26-1.16V31.82a1.3 1.3 0 0 0-.38-1l-3.87-3.6a2.62 2.62 0 0 1-.51-1c0-.39.39-.51.77-.51h12.36c.51 0 .64.25.64.77z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.47 10.91v105.05h41.45V10.91h-41.45",
    fill: "#1e3278"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.71 63.96c0 31.79-7 38.87-15.32 38.87s-15.17-7.08-15.17-38.87c0-25.36 6.95-32.7 15.18-32.7s15.31 7.34 15.31 32.7zm-10 0c0-22.4-1.8-27.16-5.28-27.16s-5.21 4.76-5.21 27.16c0 29 1.8 33.33 5.14 33.33s5.31-4.37 5.31-33.33z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaPennsylvaniaKeno);
export default __webpack_public_path__ + "static/media/usa_pennsylvania_keno.05d1ee98392d1bd418575319552cb8e8.svg";
export { ForwardRef as ReactComponent };